module.exports = __webpack_public_path__ + "static/media/opportunityTitle.58211d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/opportunityTitle.png
// module id = 451
// module chunks = 0